module.exports = __webpack_public_path__ + "static/media/picture-(175).719a685c.JPG";